import { SET_HISTORY_FIELD} from '../Actions/History.action';

const defaultState = {
	apptId: '',
	typeAppt: 'add'
};

export const history = (state = defaultState, action) => {
	const {type, payload} = action;
	if (!payload) return state;
	let {listValue} = payload;
	switch (type) {
		case SET_HISTORY_FIELD:
			let newState = {...state};
			listValue.forEach(e => {
				newState = {
					...newState,
					[e.key] : e.value
				}
			})
			return {
				...newState
			}
		default:
			return state;
	}
}
